import React, { useContext, useState } from 'react'

import UserFavoritedFixtures from '../components/Profile/UserFavoritedFixtures'
import AddFixture from '../components/Public/Fixtures/AddFixture'
import AllFixtures from '../components/Public/Fixtures/AllFixtures'
import StateContext from '../StateContext'

function FixturesPage() {

    const appState = useContext(StateContext)

    const [show, setShow] = useState(false)

    function toggle() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    return (
    
        <div className="container my-4">
            {appState.loggedIn && (
                <>

                <button onClick={toggle} className="btn btn-success">Add fixture</button>
                {show && <AddFixture setShow={setShow} />}

                <div className="card card-header font-weight-bold">Favorittkamper</div>
                <UserFavoritedFixtures />
                </>
            )}
            <div className="card card-header font-weight-bold mt-3">Alle kamper</div>
            <AllFixtures />
        </div>

    )
}
export default FixturesPage